import API from "./config";

export default class FilterAPI {
  // Screen 1 -------------------------------------------
  static getRegionsData() {
    return API.get("/regions");
  }
  static getMapDetialsScreen1() {
    return API.get("/s1_map_detail");
  }
  static getScoresDataScreen1(request_data) {
    return API.post("/s1_scores_data", request_data);
  }
  static getOutcomeDataScreen1(request_data) {
    return API.post("/s1_outcome_data", request_data);
  }
  static getDemographicDataScreen1(request_data) {
    return API.post("/s1_demographic_data", request_data);
  }

  // Screen 2 --------------------------------------------
  static getAverageDetailsScreen2(request_data) {
    return API.post("/s2_average_data", request_data);
  }
  static getCountDetailsScreen2(request_data) {
    return API.post("/s2_count_data", request_data);
  }
  static getPercentDetailsScreen2(request_data) {
    return API.post("/s2_percent_data", request_data);
  }
  static getGrowthDetailsScreen2(request_data) {
    return API.post("/s2_growth_data", request_data);
  }

  // Screen 3 --------------------------------------------
  static getAllIndustryNamesScreen3() {
    return API.get("/s3_industries");
  }
  static getAverageDetailsScreen3(request_data) {
    return API.post("/s3_average_data", request_data);
  }
  static getAgeDetailsScreen3(request_data) {
    return API.post("/s3_age_data", request_data);
  }
  static getRaceDetailsScreen3(request_data) {
    return API.post("/s3_race_data", request_data);
  }
  static getGenderDetailsScreen3(request_data) {
    return API.post("/s3_gender_data", request_data);
  }
  static getRegionalConcentrationDetailsScreen3(request_data) {
    return API.post("/s3_regional_concentration_data", request_data);
  }
  static getRegionalMigrationDetailsScreen3(request_data) {
    return API.post("/s3_regional_migration_data", request_data);
  }

  // Screen 4 --------------------------------------------
  static getAverageDetailsScreen4(request_data) {
    return API.post("/s4_average_data", request_data);
  }
  static getCountDetailsScreen4(request_data) {
    return API.post("/s4_count_data", request_data);
  }
  static getPercentDetailsScreen4(request_data) {
    return API.post("/s4_percent_data", request_data);
  }
  static getGrowthDetailsScreen4(request_data) {
    return API.post("/s4_growth_data", request_data);
  }

  // Screen 5 --------------------------------------------
  static getAllOccupationNamesScreen5() {
    return API.get("/s5_occupations");
  }
  static getAverageDetailsScreen5(request_data) {
    return API.post("/s5_average_data", request_data);
  }
  static getIncomeDetailsScreen5(request_data) {
    return API.post("/s5_income_data", request_data);
  }
  static getIncomeDiffDetailsScreen5(request_data) {
    return API.post("/s5_income_diff_data", request_data);
  }
  static getAgeDetailsScreen5(request_data) {
    return API.post("/s5_age_data", request_data);
  }
  static getRaceDetailsScreen5(request_data) {
    return API.post("/s5_race_data", request_data);
  }
  static getGenderDetailsScreen5(request_data) {
    return API.post("/s5_gender_data", request_data);
  }

  // Screen 6 --------------------------------------------
  static getAverageDetailsScreen6(request_data) {
    return API.post("/s6_average_data", request_data);
  }
  static getEducationSummaryDetailsScreen6(request_data) {
    return API.post("/s6_education_summary_data", request_data);
  }
  static getEducationAttainmentDetailsScreen6(request_data) {
    return API.post("/s6_education_attainment_data", request_data);
  }
  static getCTEfilterData(request_data) {
    return API.get("/cte-dropdown", request_data);
  }
  static getCTEbarChartData(request_data) {
    return API.post("/cte-bargraph", request_data);
  }
  static getCTELeftSunburstData(request_data) {
    return API.post("/cte-sunburst-left", request_data);
  }
  static getCTERightSunburstData(request_data) {
    return API.post("/cte-sunburst-right", request_data);
  }
  static getEducationSummaryCards(request_data) {
    return API.post("/s6_education_summary_cards", request_data);
  }
  static getGradPostEducationSummary(request_data) {
    return API.post("/s6_grad_post_summary", request_data);
  }
  static getGradPostSubgroupSummary(request_data) {
    return API.post("/s6_grad_post_subgroup_summary", request_data);
  }
  static getNAEPTableData(request_data) {
    return API.get("/s6_naep_table_data", request_data);
  }
  static getCompletionsOverTime(request_data) {
    return API.post("/s6_completions_over_time", request_data);
  }
  static getCompletionsByDegreeType(request_data) {
    return API.post("/s6_completions_by_degree_type", request_data);
  }

  // Screen 7 --------------------------------------------

  static getLeftMenuDataScreen7(request_data) {
    return API.post("/s7-left-menu", request_data);
  }
  static getTreeMapDataScreen7(request_data) {
    return API.post("/s7-treemap", request_data);
  }
  static getBarChartDataScreen7(request_data) {
    return API.post("/s7-pipeline", request_data);
  }
  static getFeederDataScreen7(request_data) {
    return API.post("/s7-pipeline-feeders", request_data);
  }
}
